import { render, staticRenderFns } from "./MetricColumn.vue?vue&type=template&id=1e6f4303&scoped=true"
import script from "./MetricColumn.vue?vue&type=script&lang=js"
export * from "./MetricColumn.vue?vue&type=script&lang=js"
import style0 from "./MetricColumn.vue?vue&type=style&index=0&id=1e6f4303&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6f4303",
  null
  
)

export default component.exports